var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.content)?_c(_vm.carouselComponentName,{tag:"component",attrs:{"headline":_vm.headline,"content":_vm.content}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }